import { twMerge } from "tailwind-merge";
import { LicensePlate } from "../LicensePlate";

type VehicleData = {
  licenseplate: string;
  brand?: string;
  model?: string;
  color?: string;
  isValid: boolean;
};

interface LicensePlateInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  wrapperClassName?: string;
  className?: string; // Class names for the input field. See TODO comment below.
  country?: "NL" | "BE";
  vehicleData?: VehicleData;
  isLoading?: boolean;
  errors?: React.ReactNode;
}
const LicensePlateInput = ({
  wrapperClassName, // TODO: Check current usage of className, add property 'inputFieldClassName', move classnames currently being used to inputFieldClassName, rename wrapperClassName to className
  className,
  country = "NL",
  vehicleData,
  isLoading = false,
  errors,
  ...rest
}: LicensePlateInputProps) => {
  return (
    <div
      className={twMerge(
        "flex flex-col justify-center relative",
        wrapperClassName,
      )}
    >
      <LicensePlate size="large" country={country} isLoading={isLoading}>
        <input
          className={twMerge(
            "bg-transparent",
            "placeholder-black",
            "hover:outline-none",
            "focus:outline-none",
            "active:outline-none",
            "placeholder-black/30",
            "w-full",
            className,
          )}
          placeholder="XX-XX-XX"
          type="text"
          {...rest}
        />
      </LicensePlate>

      {vehicleData?.isValid ? (
        <div className="text-center py-2">
          {vehicleData?.brand} {vehicleData?.model}
          {vehicleData?.color ? ` (${vehicleData?.color})` : null}
        </div>
      ) : null}

      {errors ? errors : null}
    </div>
  );
};

export { LicensePlateInput };
